module.exports = __webpack_public_path__ + "img/DeliveredDefault.00b98ea8.svg";